export const commonenv = {
  production: true,
  apiUrl: 'https://vaa.aesthetic-works.net',
  sentry_public_dsn: null,
  release: 'prod',
};
